<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    长龙站<br>
站点介绍<br>
长龙站位于吉华路路中，沿吉华路布置。车站周边是办公、商住楼、布吉中学、森鑫源职业培训学校等教育机构和旧工业区。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:10	23:17	5号线	3分钟	5分25秒<br>
黄贝岭	06:10	00:04	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:22	23:17	5号线	4分钟	6分钟<br>
黄贝岭	06:12	00:04	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:22	00:17	5号线	4分钟	6分钟<br>
黄贝岭	06:12	01:04	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
吉华路西侧（北）、西环路西侧、丽廷豪苑、布吉一村工业区、文博宫、大坡头村、深圳万东医院、大坡头村办公楼<br><br>
B出入口:<br>
吉华路西侧（南）、龙岗区第二人民医院、布吉老干部活动中心、汇洋大厦、龙岭学校、宝龙花园<br><br>
C1出入口:<br>
吉华路北侧<br><br>
C2出入口:<br>
吉华路南侧、布吉中学、布吉公园、德兴城、长龙新村、金鹏大厦、深圳市场监督管理局龙岗分局布吉监管所<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 西环吉华路口<br>
306、956、M265、M428、M463、M541<br><br>
B出入口:<br>
公交站名： 布吉中学<br>
303、61、307、308、312、956、980、M428、M265、M267、M271、M272、M402、M414、M415、高峰专线29号、M138、M463、M541<br><br>
C2出入口:<br>
公交站名： 布吉中学<br>
303、61、307、308、312、956、980、M428、M265、M267、M271、M272、M402、M414、M415、高峰专线29号、306、M565、369、M138、M463、M541<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


